import React, { Fragment } from "react";
import AuthService from "../../../AuthService";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import {
  Box,
  Button,
  styled,
  TextField,
  Divider,
  ListItemIcon,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TimerIcon from "@mui/icons-material/Timer";
import SportsMotorsportsIcon from "@mui/icons-material/SportsMotorsports";
import { ReactComponent as QrCodeIcon } from "../../../imagens/qr_code.svg";
import { useNavigate } from "react-router-dom";

const RADIUS_DOT = 6;

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "50px",
  maxHeight: "30px",
}));

const StyledQrCodeIcon = styled(QrCodeIcon)(({ theme }) => ({
  fill: theme.palette.primary.main,
  transition: "scale 0.3s ease",
  "&:hover": {
    scale: "1.1",
  },
}));

const StyledSportsMotorsportsIcon = styled(SportsMotorsportsIcon)(
  ({ theme }) => ({
    color: theme.palette.primary.main,
    transition: "scale 0.3s ease",
    "&:hover": {
      scale: "1.1",
    },
  })
);

const Circle = styled("span")(() => ({
  borderRadius: RADIUS_DOT,
  height: RADIUS_DOT * 2,
  width: RADIUS_DOT * 2,
  padding: 0,
  display: "block",
}));

const ColoredCircle = ({ styles }) => {
  return styles ? (
    <Fragment>
      <Circle style={styles} />
    </Fragment>
  ) : null;
};

export default function StatusLoja() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [statusLoja, setStatusLoja] = React.useState(
    localStorage.getItem("_statusAberturaDelivery")
  );
  const [configuracaoAberturaDelivery, setConfiguracaoAberturaDelivery] =
    React.useState(localStorage.getItem("_configuracaoAberturaDelivery"));
  const [configuracaoAberturaComanda, setConfiguracaoAberturaComanda] =
    React.useState(localStorage.getItem("_configuracaoAberturaComanda"));
  const [statusLojaComanda, setStatusLojaComanda] = React.useState(
    localStorage.getItem("_statusAberturaComanda")
  );
  const navigate = useNavigate();

  const setStatusRetorno = (retorno) => {
    setStatusLoja(retorno[0].statusAbertura);
    setConfiguracaoAberturaDelivery(retorno[0].configuracaoAbertura);
    localStorage.setItem("_statusAberturaDelivery", retorno[0].statusAbertura);
    localStorage.setItem(
      "_configuracaoAbertura",
      retorno[0].configuracaoAbertura
    );

    setStatusLojaComanda(retorno[1].statusAbertura);
    setConfiguracaoAberturaComanda(retorno[1].configuracaoAbertura);
    localStorage.setItem("_statusAberturaComanda", retorno[1].statusAbertura);
    localStorage.setItem(
      "_configuracaoAbertura",
      retorno[1].configuracaoAbertura
    );
  };

  React.useEffect(() => {
    let service = new AuthService();
    service
      .get("/empresa/statusLoja?tipo=AMBOS")
      .then((resp) => {
        setStatusRetorno(resp);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (value, tipo) => {
    let service = new AuthService();
    let status = {
      configuracaoAbertura: value,
      tipo: tipo,
    };
    service
      .post("/empresa/configuracaoAbertura", status)
      .then((resp) => {
        setStatusRetorno(resp);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Box paddingRight={1}>
      <Box>
        <StyledButton onClick={handleClick} variant="contained">
          <ColoredCircle
            styles={{
              backgroundColor: statusLoja === "ABERTO" ? "#66bb6a" : "#C30010",
            }}
          />
          <StyledSportsMotorsportsIcon />
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
          <ColoredCircle
            styles={{
              backgroundColor:
                statusLojaComanda === "ABERTO" ? "#66bb6a" : "#C30010",
            }}
          />
          <StyledQrCodeIcon />
        </StyledButton>
      </Box>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Box sx={{ p: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "column", mb: 1 }}>
            <Box sx={{ pl: 1, display: "flex", alignItems: "center" }}>
              <ColoredCircle
                styles={{
                  backgroundColor:
                    statusLoja === "ABERTO" ? "#66bb6a" : "#C30010",
                }}
              />
              <ListItemText
                sx={{ ml: 1 }}
                primary={
                  statusLoja === "ABERTO"
                    ? "Delivery aberto"
                    : "Delivery Fechado"
                }
              />
            </Box>
            <Box sx={{ p: 1, display: "flex", alignItems: "center" }}>
              <ColoredCircle
                styles={{
                  backgroundColor:
                    statusLojaComanda === "ABERTO" ? "#66bb6a" : "#C30010",
                }}
              />
              <ListItemText
                sx={{ ml: 1 }}
                primary={
                  statusLojaComanda === "ABERTO"
                    ? "Comanda / Mesa aberto"
                    : "Comanda / Mesa Fechado"
                }
              />
            </Box>
          </Box>

          <Divider />

          <Box sx={{ display: "grid", mt: 1, mb: 3 }}>
            <SelectOneMenu
              handleItemClick={handleItemClick}
              selected={configuracaoAberturaDelivery}
              label={"Delivery"}
              tipo={"DELIVERY"}
            />
            <SelectOneMenu
              handleItemClick={handleItemClick}
              selected={configuracaoAberturaComanda}
              label={"Comanda/Mesa"}
              tipo={"COMANDA"}
            />
          </Box>

          <Divider />
          <Box sx={{ mt: 1 }}>
            <MenuItem onClick={() => navigate("/HorarioAbertura")}>
              <ListItemIcon>
                <AccessTimeIcon />
              </ListItemIcon>
              <ListItemText primary="Configurar horários" />
            </MenuItem>
          </Box>

          <MenuItem onClick={() => navigate("/Delivery#mostrarTempoEntrega")}>
            <ListItemIcon>
              <TimerIcon />
            </ListItemIcon>
            <ListItemText primary="Configurar tempo de entrega" />
          </MenuItem>
        </Box>
      </Menu>
    </Box>
  );
}

export function SelectOneMenu({ handleItemClick, selected, label, tipo }) {
  return (
    <TextField
      sx={{ mt: 2, mx: 1 }}
      variant="outlined"
      select
      name="statusImpressao"
      id="statusImpressao"
      value={selected || ""}
      size="small"
      label={label}
    >
      <MenuItem
        value={"SEMPRE_FECHADO"}
        onClick={() => handleItemClick("SEMPRE_FECHADO", tipo)}
      >
        <ListItemText primary="Loja sempre fechada" />
      </MenuItem>
      <MenuItem
        value={"SEMPRE_ABERTO"}
        onClick={() => handleItemClick("SEMPRE_ABERTO", tipo)}
      >
        <ListItemText primary="Loja sempre aberta" />
      </MenuItem>
      <MenuItem
        value={"AUTOMATICO"}
        onClick={() => handleItemClick("AUTOMATICO", tipo)}
      >
        <ListItemText
          primary="Automático"
          secondary="Abrir com o monitor de impressão"
        />
      </MenuItem>
    </TextField>
  );
}
